"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BundlePage = require("./BundlePage");

var _PlanButton = _interopRequireDefault(require("./PlanButton"));

function ServicePlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var servicePlanSelected = state.servicePlanSelected;

  var onSelectedChange = function onSelectedChange() {
    var updatedSelectedMerch = servicePlanSelected === merchandiseId ? null : merchandiseId;
    setState({
      servicePlanSelected: updatedSelectedMerch,
      serviceUnits: 0
    });
  };

  return _react.default.createElement(_PlanButton.default, {
    edition: edition,
    merchandiseId: merchandiseId,
    selected: servicePlanSelected === merchandiseId,
    onSelectedChange: onSelectedChange
  });
}

var _default = ServicePlanButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/ServicePlanButton.js
// module id = 705
// module chunks = 5 6